export const getBreadCrumb = (area, pref, golfName) => {
  if (!area) {
    return [
      { text: 'ゴルフ場の天気' }
    ]
  } else if (!pref) {
    if (area === 'okinawa') {
      return [
        { text: 'ゴルフ場の天気', link: '../' },
        { text: getPrefectureName(area) }
      ]
    }
    return [
      { text: 'ゴルフ場の天気', link: '../' },
      { text: areaToPrefTable.find(({ key }) => key === area).name }
    ]
  } else if (!golfName) {
    return [
      { text: 'ゴルフ場の天気', link: '../../' },
      { text: areaToPrefTable.find(({ key }) => key === area).name, link: '../' },
      { text: getPrefectureName(pref) }
    ]
  } else {
    return [
      { text: 'ゴルフ場の天気', link: '../../../' },
      { text: areaToPrefTable.find(({ key }) => key === area).name, link: '../../' },
      { text: getPrefectureName(pref), link: '../' },
      { text: golfName }
    ]
  }
}
